<div class="text-3xl font-medium text-gray-900 dark:text-white ml-3">
  Mes Soumissions
  <p class="text-sm dark:bg-gray-700 dark:text-gray-400">
    Vous trouverez ici vos dossiers de candidature
  </p>
  <br />
</div>
<div *ngIf="showSubmission">
  <p class="w-full text-2xl text-left rtl:text-right text-gray-500 dark:text-gray-400">
    Vous n'avez candidater à aucun certificat, <br />consulter la liste de nos
    certificats ci-dessous et postulez!
  </p>
</div>
<!--Call spinner-->

<div class="relative overflow-x-auto rounded-lg" *ngIf="showHeaderOfTable">
  <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
    <thead class="text-sm text-white bg-red-700 dark:bg-gray-700 dark:text-gray-400">
      <tr>
        <th scope="col" class="px-6 py-3">Titre de l'appel</th>
        <th scope="col" class="px-6 py-3">Date de Clôture</th>
        <th scope="col" class="px-6 py-3">Date de Soumission</th>
        <th scope="col" class="px-6 py-3">Etat</th>
      </tr>
    </thead>

    <tbody>
      <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700" *ngFor="let submission of submissions">
        <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
          {{ submission.application.applicationName }}
        </th>
        <td class="px-6 py-4">
          {{
          submission.application.closeDate | date : " le d MMMM yyyy à HH:mm"
          }}
        </td>
        <td class="px-6 py-4">
          {{ submission.registeredAt | date : " le d MMMM yyyy à HH:mm" }}
        </td>
        <td class="px-6 py-4">
          <div class="sm rounded-lg p-1 text-white w-24 text-center" [style.backgroundColor]="
              submission.applicationStatus == 'Retenu'
                ? '#28b45b'
                : submission.applicationStatus == 'En cours'
                ? '#1d71b8'
                : '#f04438'
            ">
            {{ submission.applicationStatus }}
          </div>
        </td>
        <!-- <td class="px-6 py-4">
          <svg
            class="w-4 h-4 text-gray-600 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 4 15"
          >
            <path
              d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
            />
          </svg>
        </td> -->
      </tr>
    </tbody>
  </table>
</div>
<div class="border-t border-gray-300 my-6"></div>

<div class="flex justify-between mr-3">
  <div class="text-2xl font-medium text-gray-900 dark:text-white ml-3">
    Appels à candidature
  </div>
  <div class="flex bg-white border border-gray-300 rounded p-2 ml-6">
    <svg class="w-5 h-5 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
      viewBox="0 0 20 19">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="m9 12 5.419 3.871A1 1 0 0 0 16 15.057V2.943a1 1 0 0 0-1.581-.814L9 6m0 6V6m0 6H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h7m-5 6h3v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5Zm15-3a3 3 0 0 1-3 3V6a3 3 0 0 1 3 3Z" />
    </svg>
    <span class="ms-2 text-sm text-gray-900 dark:text-white">Tous les appels</span>
  </div>
</div>
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
  <div class="bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 m-6"
    *ngFor="let appel of appels">
    <figure class="relative">
      <a [routerLink]="['soumission/' + appel.id]">
        <img class="rounded-t-lg" src="assets/img/image-3.png" alt="" width="100%" />
        <figcaption class="absolute px-4 text-lg text-white top-2 rounded">
          <a routerLink="/register"
            class="mb-6 px-3 py-2 text-sm font-medium text-center text-white bg-green-500 rounded-full hover:bg-green-500 focus:ring-4 focus:outline-none focus:ring-green-300 dark:bg-green-500 dark:hover:bg-green-600 dark:focus:ring-green-600">
            Inscriptions en cours
          </a>
        </figcaption>
      </a>
    </figure>
    <div class="p-5">
      <a href="#">
        <div class="mb-2 text-xl text-gray-900 dark:text-white">
          {{ appel.applicationName }}
        </div>
      </a>
      <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">
        {{ appel.applicationInformations }}
      </p>
      <a [routerLink]="['soumission/' + appel.id]"
        class="inline-flex float-right mb-6 px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
        Continuer
        <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2 mt-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
          fill="none" viewBox="0 0 14 10">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M1 5h12m0 0L9 1m4 4L9 9" />
        </svg>
      </a>
    </div>
  </div>
</div>